import { Box, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DownloadRoundedIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom';

const SuccessPayment = () => {
  const { t } = useTranslation(['mobilityvoucher']);
  const navigate = useNavigate();
  const goToHome = () => {
    navigate('/mobilityvoucher/orders')
  }
  return (
    <>
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        alignItems={'center'}
        paddingTop={'110px'}
        paddingBottom={'230px'}
      >
        <DoneAllIcon />
        <h4>{t("checkout.operationSuccess")}</h4>
        <p>
          {t("checkout.operationSuccessDetail")}<br/>
        </p>
        <Stack direction="row" spacing={2} alignItems={"center"}>
          {/* <Button variant="outlined" size='smallPlus' endIcon={<DownloadRoundedIcon />}>
            {t("buttons.downloadPDF")}
          </Button> */}
          <Button onClick={goToHome} variant="contained" size='smallPlus'>
            {t("buttons.goHome")}
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default SuccessPayment;